var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Typography, IconButton, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Box, Stack, tableCellClasses, Popover, Divider, Chip, Link, Button, MenuItem, Select, Tooltip, } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { UserApproveIcon, UserDenyIcon, UserDeactivateIcon, MoreActionIcon, EditPencilIcon, ResubmitApplicationIcon, } from "../icons";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { PORTAL_STATUS, RESUBMIT_APPLICATION_STATUS, } from "../ModuleHeader/ModuleHeader";
import "./../../assets/scss/moduleTable.scss";
import { AdminMangementDataEnum, ApplicationManagementEnum, DealerMangementDataEnum, MarketingContentEnum, ResubmitApplicationDataEnum, SupportTicketDataEnum, UserMangementDataEnum, CustomerPortalUserManagementDataEnum, CustomerPortalPaymentManagementDataEnum, CustomerPortalSupportManagementDataEnum, CustomerPortalUserNotificationDataEnum, CustomerPortalRegistrationManagementDataEnum, AdminRegisteredUsersDataEnum, } from "../../config/TableColumns";
import { formatCurrency, maskPhoneNumber, getPhoneActionLabel } from "../../utils/commonUtilities";
import DeleteIcon from "../icons/DeleteIcon";
import AppDetailsIcon from "../icons/AppDetailsIcon";
import TrashCanIcon from "../icons/TrashCanIcon";
import ReplayIcon from "@mui/icons-material/Replay";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FileCopyIcon from "@mui/icons-material/FileCopy";
export var BasicPopover = function (_a) {
    var rowData = _a.rowData, tooltipActionHandler = _a.tooltipActionHandler, moduleType = _a.moduleType, scrollCounter = _a.scrollCounter, useCustomerPortalMenu = _a.useCustomerPortalMenu, _b = _a.hideEditIcon, hideEditIcon = _b === void 0 ? false : _b, _c = _a.hasDelete, hasDelete = _c === void 0 ? true : _c, _d = _a.canUpdate, canUpdate = _d === void 0 ? true : _d, _e = _a.showImpersonate, showImpersonate = _e === void 0 ? false : _e;
    var _f = React.useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? "simple-popover" : undefined;
    return (React.createElement("div", null,
        React.createElement(IconButton, { onClick: handleClick, sx: {
                color: {
                    opacity: moduleType !== "Admin Management" &&
                        moduleType !== "Customer Portal User Management"
                        ? (rowData === null || rowData === void 0 ? void 0 : rowData.Status) == 0 ||
                            (rowData === null || rowData === void 0 ? void 0 : rowData.Status) == 2
                            ? 0.5
                            : 1
                        : 1,
                },
                pointerEvents: moduleType !== "Admin Management" &&
                    moduleType !== "Customer Portal User Management"
                    ? rowData.Status == 0 ||
                        (rowData === null || rowData === void 0 ? void 0 : rowData.Status) == 2
                        ? "none"
                        : "auto"
                    : "auto",
            } },
            React.createElement(MoreActionIcon, null)),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "center",
            } },
            moduleType === "Admin Management" && (React.createElement(Stack, null, !hideEditIcon && (React.createElement(Stack, { direction: "row", sx: { cursor: "pointer" }, alignItems: "center", onClick: function () {
                    tooltipActionHandler(rowData, "Edit");
                    setAnchorEl(null);
                } },
                React.createElement(IconButton, null,
                    React.createElement(EditPencilIcon, null)),
                React.createElement(Typography, { color: "#000000", fontSize: "14px", paddingRight: "8px" }, "Edit"))))),
            moduleType === "User Management" && (React.createElement(Stack, null,
                canUpdate &&
                    (rowData.userStatus === 0 || rowData.userStatus === 2) &&
                    rowData.RoleType !== "VENDSREP" &&
                    rowData.RoleType !== "CUSTOMER" && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Approved");
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, null,
                        React.createElement(UserApproveIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px", paddingRight: "8px" }, "Approve"))),
                canUpdate &&
                    (rowData.userStatus === 0 || rowData.userStatus === 1) &&
                    rowData.RoleType !== "VENDSREP" &&
                    rowData.RoleType !== "CUSTOMER" &&
                    rowData.userStatus !== 2 && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Denied");
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, null,
                        React.createElement(UserDenyIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px", paddingRight: "8px" }, "Deny"))),
                canUpdate &&
                    rowData.userStatus !== "Deactivated" && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Deactivated");
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, null,
                        React.createElement(UserDeactivateIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px", paddingRight: "8px" }, "Deactivate User"))),
                rowData.userStatus !== "Deactivated" && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "impersonate");
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, { sx: { width: "36px" } },
                        React.createElement(SupervisorAccountIcon, { sx: { color: "#363948" } })),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px", paddingRight: "8px" }, "Impersonate"))))),
            moduleType === "Marketing Content" && (React.createElement(Stack, { p: "2px 8px 0px 4px" }, rowData.Status !== 3 ? (React.createElement(React.Fragment, null,
                !hideEditIcon && (React.createElement(React.Fragment, null,
                    React.createElement(Stack, { direction: "row", onClick: function () {
                            tooltipActionHandler(rowData, "EDIT");
                            setAnchorEl(null);
                        }, sx: { cursor: "pointer" }, alignItems: "center" },
                        React.createElement(IconButton, { size: "small" },
                            React.createElement(EditPencilIcon, null)),
                        React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "\u00A0\u00A0Edit")),
                    hasDelete && React.createElement(Divider, null))),
                hasDelete && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "DELETE");
                        setAnchorEl(null);
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(DeleteIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Delete"))))) : (React.createElement(React.Fragment, null, !hideEditIcon && (React.createElement(React.Fragment, null,
                React.createElement(Divider, null),
                React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "EDIT");
                        setAnchorEl(null);
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(ReplayIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Re Activate")))))))),
            moduleType === "Dealer Program Association" && (React.createElement(Stack, { p: "2px 8px 0px 4px" },
                !hideEditIcon && (React.createElement(React.Fragment, null,
                    React.createElement(Stack, { direction: "row", sx: { cursor: "pointer" }, alignItems: "center", onClick: function () {
                            tooltipActionHandler(rowData, "Edit");
                            setAnchorEl(null);
                        } },
                        React.createElement(IconButton, { size: "small" },
                            React.createElement(EditPencilIcon, null)),
                        React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "\u00A0\u00A0Edit")),
                    hasDelete && React.createElement(Divider, null))),
                hasDelete && (React.createElement(Stack, { direction: "row", sx: { cursor: "pointer" }, alignItems: "center", onClick: function () {
                        tooltipActionHandler(rowData, "Delete");
                        setAnchorEl(null);
                    } },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(DeleteIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Delete"))))),
            moduleType === "Program Management" && (React.createElement(Stack, { p: "2px 8px 0px 4px" },
                !hideEditIcon && (React.createElement(React.Fragment, null,
                    React.createElement(Stack, { direction: "row", sx: { cursor: "pointer" }, alignItems: "center", onClick: function () {
                            tooltipActionHandler(rowData, "Edit");
                            setAnchorEl(null);
                        } },
                        React.createElement(IconButton, { size: "small" },
                            React.createElement(EditPencilIcon, null)),
                        React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "\u00A0\u00A0Edit")),
                    hasDelete && React.createElement(Divider, null))),
                hasDelete && (React.createElement(Stack, { direction: "row", sx: { cursor: "pointer" }, alignItems: "center", onClick: function () {
                        tooltipActionHandler(rowData, "Delete");
                        setAnchorEl(null);
                    } },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(DeleteIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Delete"))))),
            moduleType === "Resubmit Application" && (React.createElement(Stack, { p: "8px 8px 8px 4px", spacing: 1.5 },
                React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "AppDetails");
                        setAnchorEl(null);
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(AppDetailsIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "16px" }, "\u00A0\u00A0App Summary")),
                canUpdate && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Resubmit");
                        setAnchorEl(null);
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(ResubmitApplicationIcon, { isFromSideMenu: false })),
                    React.createElement(Typography, { color: "#000000", fontSize: "16px" }, "\u00A0\u00A0Re Submit"))),
                hasDelete && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Delete");
                        setAnchorEl(null);
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(TrashCanIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "16px" }, "\u00A0\u00A0Delete"))))),
            moduleType === "Customer Portal User Management" &&
                useCustomerPortalMenu && (React.createElement(Stack, { p: "8px 0px" },
                (rowData.Status === 1) && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "AssociateAccount");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Associate Account"))),
                (rowData.Status === 1) && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Edit");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Edit User"))),
                (rowData.Status === 1) && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "ViewDetails");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "View Details"))),
                (rowData.Status === 1) && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "VerifyPhone");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, getPhoneActionLabel(rowData.PhoneNumber, rowData.IsPhoneVerified)))),
                (rowData.Status === 1) && showImpersonate && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Impersonate");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Impersonate"))),
                rowData.Status === 1 ? (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Deactivate");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#d32f2f", fontSize: "14px" }, "Deactivate User"))) : (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Activate");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#2e7d32", fontSize: "14px" }, "Activate User"))))),
            moduleType ===
                "Customer Portal Registration Management" && (React.createElement(Stack, { p: "8px 0px" },
                rowData.RegistrationStatus === "Failed" && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "EditRetry");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Edit & Retry"))),
                (rowData.RegistrationStatus === "LinkGenerated" ||
                    rowData.RegistrationStatus === "LinkExpired") && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "CopyLink");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Copy Link"))),
                (rowData.RegistrationStatus === "Pending" ||
                    rowData.RegistrationStatus === "LinkGenerated" ||
                    rowData.RegistrationStatus === "LinkExpired") && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "ResendLink");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Resend Link"))),
                React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "ViewDetails");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "View Details")))),
            moduleType === "Customer Portal Admin Registered Users" && (React.createElement(Stack, { p: "8px 0px" },
                rowData.RegistrationLink && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "CopyLink");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Copy Link"))),
                rowData.Status === "PENDING" && (React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "ResendLink");
                        setAnchorEl(null);
                    }, sx: {
                        cursor: "pointer",
                        py: 1,
                        px: 2,
                        "&:hover": { backgroundColor: "#f0f0f0" },
                    }, alignItems: "center" },
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Resend Link"))))),
            moduleType === "Customer Portal User Management" &&
                !useCustomerPortalMenu && (React.createElement(Stack, { p: "2px 8px 0px 4px" },
                React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Edit");
                        setAnchorEl(null);
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(EditPencilIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "\u00A0\u00A0Edit")),
                React.createElement(Divider, null),
                React.createElement(Stack, { direction: "row", onClick: function () {
                        tooltipActionHandler(rowData, "Delete");
                        setAnchorEl(null);
                    }, sx: { cursor: "pointer" }, alignItems: "center" },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(DeleteIcon, null)),
                    React.createElement(Typography, { color: "#000000", fontSize: "14px" }, "Delete")))))));
};
var StyledTableCell = styled(TableCell)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(tableCellClasses.head)] = {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            padding: "0px 16px",
            height: "40px",
            borderRight: "none !important",
            borderLeft: "none !important",
        },
        _b["&.".concat(tableCellClasses.body)] = {
            fontSize: 14,
            borderRight: "none !important",
            borderLeft: "none !important",
        },
        _b);
});
var SORT_ORDER;
(function (SORT_ORDER) {
    SORT_ORDER["ASC"] = "ASC";
    SORT_ORDER["DESC"] = "DESC";
})(SORT_ORDER || (SORT_ORDER = {}));
var sortColumnName = "";
var sortOrder = SORT_ORDER.ASC;
var ModuleTable = function (_a) {
    var columns = _a.columns, dataToDisplay = _a.dataToDisplay, isLoading = _a.isLoading, isActionColumn = _a.isActionColumn, actionHandler = _a.actionHandler, moduleName = _a.moduleName, isRowClickEnabled = _a.isRowClickEnabled, onClickHandler = _a.onClickHandler, isPortalSelected = _a.isPortalSelected, hasDelete = _a.hasDelete, rowDeleteClick = _a.rowDeleteClick, activePage = _a.activePage, recordsPerPage = _a.recordsPerPage, setActivePage = _a.setActivePage, setRecordsPerPage = _a.setRecordsPerPage, totalNumberOfRecords = _a.totalNumberOfRecords, hideEditIcon = _a.hideEditIcon, useCustomerPortalMenu = _a.useCustomerPortalMenu, _b = _a.tableContainerMaxHeight, tableContainerMaxHeight = _b === void 0 ? "calc(100vh - 200px)" : _b, _c = _a.canUpdate, canUpdate = _c === void 0 ? true : _c, customerPoratl = _a.customerPoratl, _d = _a.showImpersonate, showImpersonate = _d === void 0 ? false : _d, _e = _a.hidePagination, hidePagination = _e === void 0 ? false : _e, _f = _a.wrapperClassName, wrapperClassName = _f === void 0 ? "" : _f, onSortChange = _a.onSortChange, currentSortByKey = _a.currentSortByKey, _g = _a.currentSortOrder, currentSortOrder = _g === void 0 ? "ASC" : _g, _h = _a.useServerSideSorting, useServerSideSorting = _h === void 0 ? false : _h;
    var _j = useState(dataToDisplay !== null && dataToDisplay !== void 0 ? dataToDisplay : []), tableData = _j[0], setTableData = _j[1];
    var _k = useState(recordsPerPage ? recordsPerPage : 50), perPageCount = _k[0], setPerPageCount = _k[1];
    var _l = useState(activePage ? activePage : 1), currentPage = _l[0], setCurrentPage = _l[1];
    var _m = useState(0), scrollCounter = _m[0], setScrollCounter = _m[1];
    var getApplicationStatusColor = function (status) {
        switch (status) {
            case "Credit":
                return "#C49100";
            case "Credit More Info":
                return "#C49100";
            case "Approved":
                return "#44883E";
            case "Documents":
                return "#001E60";
            case "Declined":
                return "#A50034";
            case "Cancelled":
                return "#A50034";
            default:
                return "#C49100";
        }
    };
    var getResubmitStatusColor = function (statusCode) {
        switch (statusCode) {
            case 1:
                return "#1C64F2";
            case 2:
                return "#FF5A1F";
            default:
                return "#057A55";
        }
    };
    var getResubmitAppSyncStatus = function (appStatus) {
        switch (appStatus) {
            case "1":
                return "Processing";
            case "2":
                return "Success";
            default:
                return "Failed";
        }
    };
    var getRowData = function (index, fieldName, value, row, columnConfig) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        if (row === void 0) { row = ""; }
        if (fieldName === ApplicationManagementEnum.Amount) {
            return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value ? formatCurrency(value) : "--"));
        }
        if (fieldName === ApplicationManagementEnum.TxAspireOId) {
            return value ? (React.createElement("a", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis", href: "#", style: { color: "#1C64F2", fontWeight: 600, textDecoration: "none" }, onClick: function (e) {
                    e.preventDefault();
                    if (onClickHandler)
                        onClickHandler(row);
                } }, value)) : ("--");
        }
        switch (fieldName) {
            case ResubmitApplicationDataEnum.DateAndTime: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value ? moment(value).format("MM/DD/YYYY | hh:mm A") : "--"));
            }
            case UserMangementDataEnum.Name: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value ? "".concat(row.FirstName, " ").concat(row.LastName) : "--"));
            }
            case ResubmitApplicationDataEnum.Status: {
                if (value !== undefined || value !== null) {
                    if ((_a = RESUBMIT_APPLICATION_STATUS.find(function (obj) { return obj.code == value; })) === null || _a === void 0 ? void 0 : _a.status) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontSize: "14px", fontWeight: 600, color: getResubmitStatusColor(value) }, getResubmitAppSyncStatus(value))));
                    }
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
            }
            case UserMangementDataEnum.CreatedTime:
            case ApplicationManagementEnum.LastModifiedTime:
                {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value === null || value === void 0 ? void 0 : value.format("MM/DD/YYYY | hh:mm A")));
                }
            case CustomerPortalUserNotificationDataEnum.TimeStamp: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value ? moment(value).format("MM/DD/YYYY | hh:mm A") : "--"));
            }
            case CustomerPortalUserNotificationDataEnum.EmailNotification: {
                var messageText = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                if (!messageText || messageText === "--") {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
                }
                return (React.createElement(Tooltip, { title: messageText, arrow: true, placement: "top", enterDelay: 200, slotProps: {
                        tooltip: {
                            sx: {
                                bgcolor: ((_b = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _b === void 0 ? void 0 : _b.bgColor) || "#333333",
                                color: ((_c = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _c === void 0 ? void 0 : _c.textColor) || "#ffffff",
                                fontSize: ((_d = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _d === void 0 ? void 0 : _d.fontSize) || "13px",
                                padding: ((_e = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _e === void 0 ? void 0 : _e.padding) || "10px 12px",
                                borderRadius: ((_f = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _f === void 0 ? void 0 : _f.borderRadius) || "6px",
                                maxWidth: 500,
                            },
                        },
                        arrow: {
                            sx: {
                                color: ((_g = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _g === void 0 ? void 0 : _g.arrowColor) || "#333333",
                            },
                        },
                    } },
                    React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis", style: { cursor: "default", display: "inline-block", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, messageText)));
            }
            case ApplicationManagementEnum.Status: {
                if (value !== undefined || value !== null) {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), title: value || "", className: "txt-elipsis" },
                        React.createElement(Typography, { fontSize: "14px", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", color: getApplicationStatusColor(row.Status) }, value)));
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
            }
            case UserMangementDataEnum.Status: {
                if (value !== undefined || value !== null) {
                    if (value === PORTAL_STATUS[3].code) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontSize: "14px", fontWeight: 600, color: "#1C64F2" }, "Active")));
                    }
                    else if (value === PORTAL_STATUS[1].code) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontSize: "14px", fontWeight: 600, color: "#FF5A1F" }, "Pending")));
                    }
                    else if (value === PORTAL_STATUS[2].code) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontSize: "14px", fontWeight: 600, color: "#057A55" }, "Approved")));
                    }
                    else if (value === PORTAL_STATUS[4].code) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontSize: "14px", fontWeight: 600, color: "#FF5A1F" }, "Denied")));
                    }
                    else if (value === "Deactivated") {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontSize: "14px", fontWeight: 600, color: "#FF5A1F" }, "Deactivated")));
                    }
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
            }
            case SupportTicketDataEnum.TicketId: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                    React.createElement(Typography, { fontSize: "14px", fontWeight: 600, color: "#1C64F2" }, value || "--")));
            }
            case DealerMangementDataEnum.PortalName: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, moduleName === "Portal Management" && value ? (React.createElement("a", { href: value, target: "_blank", rel: "noopener" }, value)) : (React.createElement(React.Fragment, null, value || "--"))));
            }
            case CustomerPortalUserManagementDataEnum.Name: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value || "--"));
            }
            case CustomerPortalUserManagementDataEnum.Email: {
                if (moduleName !== "Customer Portal User Management") {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value || "--"));
                }
                var phone = row === null || row === void 0 ? void 0 : row.PhoneNumber;
                var isPhoneVerified = row === null || row === void 0 ? void 0 : row.IsPhoneVerified;
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                    React.createElement("span", { className: "txt-elipsis", style: { display: "block" } }, value || "--"),
                    React.createElement("span", { className: "txt-elipsis", style: { display: "block", fontSize: "12px" } }, phone ? (React.createElement(React.Fragment, null,
                        React.createElement("span", { style: { color: "#697386" } },
                            "Phone: ",
                            maskPhoneNumber(phone)),
                        " · ",
                        React.createElement("span", { style: { color: isPhoneVerified ? "#057A55" : "#B54708" } }, isPhoneVerified ? "Verified" : "Unverified"))) : (React.createElement("span", { style: { color: "#9AA1B1" } }, "Phone: \u2014 \u00B7 Not set")))));
            }
            case CustomerPortalUserManagementDataEnum.Status: {
                if (value !== undefined || value !== null) {
                    var statusValue = typeof value === "number"
                        ? value === 1
                            ? "Active"
                            : "Inactive"
                        : value;
                    var isActive = statusValue === "Active" || statusValue === "active" || value === 1;
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                        React.createElement(Chip, { label: statusValue || "--", size: "small", sx: {
                                fontWeight: 500,
                                borderRadius: "6px",
                                bgcolor: isActive ? "#E8F5E9" : "#d0d0d0",
                                color: isActive ? "#2E7D32" : "#616161",
                            } })));
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
            }
            case CustomerPortalRegistrationManagementDataEnum.RegistrationStatus: {
                var statusValue = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                var statusStyles = {
                    PENDING: { bg: "#FFF3CD", color: "#8A6D00", label: "Pending" },
                    FAILED: { bg: "#FEECEC", color: "#B42318", label: "Failed" },
                    LINKGENERATED: { bg: "#E3F2FD", color: "#1565C0", label: "Link Generated" },
                    LINKEXPIRED: { bg: "#F5F5F5", color: "#616161", label: "Link Expired" },
                    COMPLETED: { bg: "#E8F5E9", color: "#2E7D32", label: "Completed" },
                    Pending: { bg: "#FFF3CD", color: "#8A6D00", label: "Pending" },
                    Failed: { bg: "#FEECEC", color: "#B42318", label: "Failed" },
                    LinkGenerated: { bg: "#E3F2FD", color: "#1565C0", label: "Link Generated" },
                    LinkExpired: { bg: "#F5F5F5", color: "#616161", label: "Link Expired" },
                    Completed: { bg: "#E8F5E9", color: "#2E7D32", label: "Completed" },
                };
                var statusTooltips = {
                    Pending: "Pending: The administrator has completed the registration process. The customer still needs to set their password and sign in to the Customer Portal to complete registration.",
                    Completed: "Completed: Both the administrator and the customer have completed the registration process. The customer has successfully set their password and signed in to the Customer Portal.",
                    LinkGenerated: "Link Generated: A registration link has been generated and sent to the customer.",
                    LinkExpired: "Link Expired: The registration link has expired. A new link needs to be generated.",
                    Failed: "Failed: The registration process encountered an error and could not be completed.",
                    PENDING: "Pending: The administrator has completed the registration process. The customer still needs to set their password and sign in to the Customer Portal to complete registration.",
                    COMPLETED: "Completed: Both the administrator and the customer have completed the registration process. The customer has successfully set their password and signed in to the Customer Portal.",
                    LINKGENERATED: "Link Generated: A registration link has been generated and sent to the customer.",
                    LINKEXPIRED: "Link Expired: The registration link has expired. A new link needs to be generated.",
                    FAILED: "Failed: The registration process encountered an error and could not be completed.",
                };
                var meta = statusStyles[statusValue];
                var tooltipText = statusTooltips[statusValue];
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis", style: { display: "flex", alignItems: "center", gap: "8px" } },
                    React.createElement(Chip, { label: (meta === null || meta === void 0 ? void 0 : meta.label) || statusValue || "--", size: "small", sx: {
                            fontWeight: 500,
                            borderRadius: "6px",
                            bgcolor: (meta === null || meta === void 0 ? void 0 : meta.bg) || "#d0d0d0",
                            color: (meta === null || meta === void 0 ? void 0 : meta.color) || "#616161",
                        } }),
                    tooltipText && (React.createElement(Tooltip, { title: tooltipText, arrow: true, slotProps: {
                            tooltip: {
                                sx: {
                                    bgcolor: ((_h = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _h === void 0 ? void 0 : _h.bgColor) || "#333333",
                                    color: ((_j = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _j === void 0 ? void 0 : _j.textColor) || "#ffffff",
                                    fontSize: ((_k = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _k === void 0 ? void 0 : _k.fontSize) || "13px",
                                    padding: ((_l = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _l === void 0 ? void 0 : _l.padding) || "10px 12px",
                                    borderRadius: ((_m = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _m === void 0 ? void 0 : _m.borderRadius) || "6px",
                                },
                            },
                            arrow: {
                                sx: {
                                    color: ((_o = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _o === void 0 ? void 0 : _o.arrowColor) || "#333333",
                                },
                            },
                        } },
                        React.createElement(InfoOutlinedIcon, { style: {
                                fontSize: "20px",
                                color: (meta === null || meta === void 0 ? void 0 : meta.color) || "#616161",
                                cursor: "pointer",
                                opacity: 0.8,
                            } })))));
            }
            case CustomerPortalRegistrationManagementDataEnum.LinkExpiry:
            case CustomerPortalRegistrationManagementDataEnum.CreatedTime: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value ? moment(value).format("MM/DD/YYYY | hh:mm A") : "--"));
            }
            case AdminRegisteredUsersDataEnum.Status: {
                var statusValue = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                var statusStyles = {
                    PENDING: { bg: "#FFF3CD", color: "#8A6D00", label: "Pending" },
                    COMPLETED: { bg: "#E8F5E9", color: "#2E7D32", label: "Completed" },
                };
                var meta = statusStyles[statusValue];
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                    React.createElement(Chip, { label: (meta === null || meta === void 0 ? void 0 : meta.label) || statusValue || "--", size: "small", sx: {
                            fontWeight: 500,
                            borderRadius: "6px",
                            bgcolor: (meta === null || meta === void 0 ? void 0 : meta.bg) || "#d0d0d0",
                            color: (meta === null || meta === void 0 ? void 0 : meta.color) || "#616161",
                        } })));
            }
            case AdminRegisteredUsersDataEnum.ExpiresAt: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value ? moment(value).format("MM/DD/YYYY | hh:mm A") : "--"));
            }
            case CustomerPortalPaymentManagementDataEnum.Customer: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value || "--"));
            }
            case CustomerPortalPaymentManagementDataEnum.Amount: {
                var isStripe = (row === null || row === void 0 ? void 0 : row.Source) === "Credit Card";
                if (isStripe && value) {
                    var baseAmount = (row === null || row === void 0 ? void 0 : row.BaseAmount) || value;
                    var feeAmount = row === null || row === void 0 ? void 0 : row.FeeAmount;
                    var tooltipMsg = (React.createElement(Box, { sx: { p: 0.5, minWidth: 220 } },
                        React.createElement(Typography, { variant: "body2", sx: { fontWeight: 700, mb: 1 } }, "Stripe Payment Breakdown"),
                        React.createElement(Box, { sx: { display: "flex", justifyContent: "space-between", mb: 0.5 } },
                            React.createElement(Typography, { variant: "caption" }, "Base Amount"),
                            React.createElement(Typography, { variant: "caption", sx: { fontWeight: 600 } }, baseAmount)),
                        React.createElement(Box, { sx: { display: "flex", justifyContent: "space-between", mb: 0.5 } },
                            React.createElement(Typography, { variant: "caption" }, "Processing Fee"),
                            React.createElement(Typography, { variant: "caption", sx: { fontWeight: 600 } }, feeAmount || "--")),
                        React.createElement(Divider, { sx: { my: 0.75 } }),
                        React.createElement(Box, { sx: { display: "flex", justifyContent: "space-between" } },
                            React.createElement(Typography, { variant: "caption", sx: { fontWeight: 700 } }, "Total Charged"),
                            React.createElement(Typography, { variant: "caption", sx: { fontWeight: 700 } }, value))));
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis", style: { display: "flex", alignItems: "center", gap: 4 } },
                        value,
                        React.createElement(Tooltip, { title: tooltipMsg, arrow: true, placement: "top" },
                            React.createElement(IconButton, { size: "small", sx: { p: 0.25, color: "#1565C0" }, onClick: function (e) { return e.stopPropagation(); } },
                                React.createElement(InfoOutlinedIcon, { sx: { fontSize: 16 } })))));
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value || "--"));
            }
            case CustomerPortalPaymentManagementDataEnum.Date: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value ? moment(value).format("MMM D, YYYY") : "--"));
            }
            case CustomerPortalPaymentManagementDataEnum.Source: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, value || "--"));
            }
            case CustomerPortalPaymentManagementDataEnum.Status: {
                if (value !== undefined || value !== null) {
                    var statusValue = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                    var isProcessed = statusValue === "Processed" || statusValue === "processed";
                    var isPending = statusValue === "Pending" || statusValue === "pending";
                    var isCancelled = statusValue === "Cancelled" || statusValue === "cancelled";
                    var chipBgColor = "#F5F5F5";
                    var chipColor = "#FFFFFF";
                    if (isProcessed) {
                        chipBgColor = "#81C784";
                        chipColor = "#FFFFFF";
                    }
                    else if (isPending) {
                        chipBgColor = "#C49100";
                        chipColor = "#FFFFFF";
                    }
                    else if (isCancelled) {
                        chipBgColor = "#E57373";
                        chipColor = "#FFFFFF";
                    }
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis 222222222222222222" },
                        React.createElement(Chip, { label: value || "--", size: "small", sx: {
                                fontWeight: 500,
                                borderRadius: "16px",
                                bgcolor: chipBgColor,
                                color: chipColor,
                            } })));
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
            }
            case CustomerPortalPaymentManagementDataEnum.StripeStatus: {
                var isAchPayment = (row === null || row === void 0 ? void 0 : row.Source) === "ACH";
                if (isAchPayment) {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
                }
                var stripeStatusValue = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                if (!stripeStatusValue || stripeStatusValue === "--") {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
                }
                var isSucceeded = stripeStatusValue === "succeeded";
                var isStripePending = stripeStatusValue === "pending";
                var isFailed = stripeStatusValue === "failed";
                var isCancelled = stripeStatusValue === "cancelled";
                var isDisputed = stripeStatusValue === "disputed";
                var chipBgColor = "#F5F5F5";
                var chipColor = "#616161";
                if (isSucceeded) {
                    chipBgColor = "#81C784";
                    chipColor = "#FFFFFF";
                }
                else if (isStripePending) {
                    chipBgColor = "#C49100";
                    chipColor = "#FFFFFF";
                }
                else if (isFailed || isDisputed) {
                    chipBgColor = "#E57373";
                    chipColor = "#FFFFFF";
                }
                else if (isCancelled) {
                    chipBgColor = "#9E9E9E";
                    chipColor = "#FFFFFF";
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                    React.createElement(Chip, { label: stripeStatusValue.charAt(0).toUpperCase() + stripeStatusValue.slice(1), size: "small", sx: {
                            fontWeight: 500,
                            borderRadius: "16px",
                            bgcolor: chipBgColor,
                            color: chipColor,
                        } })));
            }
            case CustomerPortalPaymentManagementDataEnum.StripeTransactionId: {
                var transactionId = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                if (!transactionId || transactionId === "--") {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
                }
                return (React.createElement(Tooltip, { title: transactionId, arrow: true, placement: "top", enterDelay: 200 },
                    React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis", style: { cursor: "default", maxWidth: 180, display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, transactionId)));
            }
            case CustomerPortalPaymentManagementDataEnum.Comments: {
                var commentText = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                if (!commentText || commentText === "--") {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
                }
                return (React.createElement(Tooltip, { title: commentText, arrow: true, placement: "top", enterDelay: 200 },
                    React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis", style: { cursor: "default", maxWidth: 180, display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, commentText)));
            }
            case AdminMangementDataEnum.Status: {
                if (value !== undefined || value !== null) {
                    if (value === 1) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis 33333" },
                            React.createElement(Typography, { fontWeight: 600, color: "#1C64F2" }, "Active")));
                    }
                    else if (value === 2) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis 44444" },
                            React.createElement(Typography, { fontWeight: 600, color: "#FF5A1F" }, "Pending Approval")));
                    }
                    else if (value === 0) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontWeight: 600, color: "#FF5A1F" }, "Inactive")));
                    }
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
            }
            case MarketingContentEnum.Status: {
                if (value !== undefined || value !== null) {
                    if (value == 1) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontWeight: 600, color: "#057A55" }, "Live")));
                    }
                    else if (value == 2) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontWeight: 600, color: "#EB4B4B" }, "Withdrawn")));
                    }
                    else if (value == 3) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontWeight: 600, color: "#EB4B4B" }, "Expired")));
                    }
                    else if (value == 4) {
                        return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                            React.createElement(Typography, { fontWeight: 600, color: "#057A55" }, "Scheduled")));
                    }
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
            }
            case CustomerPortalSupportManagementDataEnum.Subject: {
                var subjectText = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                if (!subjectText || subjectText === "--") {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
                }
                return (React.createElement(Tooltip, { title: subjectText, arrow: true, placement: "top", enterDelay: 200, slotProps: {
                        tooltip: {
                            sx: {
                                bgcolor: ((_p = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _p === void 0 ? void 0 : _p.bgColor) || "#333333",
                                color: ((_q = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _q === void 0 ? void 0 : _q.textColor) || "#ffffff",
                                fontSize: ((_r = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _r === void 0 ? void 0 : _r.fontSize) || "13px",
                                padding: ((_s = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _s === void 0 ? void 0 : _s.padding) || "10px 12px",
                                borderRadius: ((_t = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _t === void 0 ? void 0 : _t.borderRadius) || "6px",
                                maxWidth: 500,
                            },
                        },
                        arrow: {
                            sx: {
                                color: ((_u = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _u === void 0 ? void 0 : _u.arrowColor) || "#333333",
                            },
                        },
                    } },
                    React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis", style: { cursor: "default", display: "inline-block", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, subjectText)));
            }
            case CustomerPortalSupportManagementDataEnum.Description: {
                var descriptionText = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                if (!descriptionText || descriptionText === "--") {
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
                }
                return (React.createElement(Tooltip, { title: descriptionText, arrow: true, placement: "top", enterDelay: 200, slotProps: {
                        tooltip: {
                            sx: {
                                bgcolor: ((_v = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _v === void 0 ? void 0 : _v.bgColor) || "#333333",
                                color: ((_w = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _w === void 0 ? void 0 : _w.textColor) || "#ffffff",
                                fontSize: ((_x = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _x === void 0 ? void 0 : _x.fontSize) || "13px",
                                padding: ((_y = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _y === void 0 ? void 0 : _y.padding) || "10px 12px",
                                borderRadius: ((_z = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _z === void 0 ? void 0 : _z.borderRadius) || "6px",
                                maxWidth: 500,
                            },
                        },
                        arrow: {
                            sx: {
                                color: ((_0 = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.tooltipConfig) === null || _0 === void 0 ? void 0 : _0.arrowColor) || "#333333",
                            },
                        },
                    } },
                    React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis", style: { cursor: "default", display: "inline-block", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, descriptionText)));
            }
            case CustomerPortalSupportManagementDataEnum.Status: {
                if (value !== undefined && value !== null) {
                    var statusValue = (value === null || value === void 0 ? void 0 : value.toString()) || "";
                    var isOpen = statusValue === "Open" || statusValue === "open";
                    var isInProgress = statusValue === "In Progress" ||
                        statusValue === "in progress" ||
                        statusValue === "InProgress";
                    var isClosed = statusValue === "Closed" || statusValue === "closed";
                    var chipBgColor = "#d0d0d0";
                    var chipColor = "#616161";
                    if (isOpen) {
                        chipBgColor = "#E3F2FD";
                        chipColor = "#1565C0";
                    }
                    else if (isInProgress) {
                        chipBgColor = "#FFF3E0";
                        chipColor = "#EF6C00";
                    }
                    else if (isClosed) {
                        chipBgColor = "#E8F5E9";
                        chipColor = "#2E7D32";
                    }
                    return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" },
                        React.createElement(Chip, { label: statusValue || "--", size: "small", sx: {
                                fontWeight: 500,
                                borderRadius: "6px",
                                bgcolor: chipBgColor,
                                color: chipColor,
                            } })));
                }
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), className: "txt-elipsis" }, "--"));
            }
            default: {
                return (React.createElement("span", { key: "".concat(fieldName, "-").concat(index), title: value || "", className: "txt-elipsis" }, value || "--"));
            }
        }
    };
    var handleSort = function (sortColKey, colDataType) {
        if (useServerSideSorting && onSortChange) {
            var nextSortOrder = currentSortByKey === sortColKey && currentSortOrder === "ASC"
                ? "DESC"
                : "ASC";
            onSortChange(sortColKey, nextSortOrder);
            return;
        }
        if (sortOrder === SORT_ORDER.ASC) {
            sortOrder = SORT_ORDER.DESC;
        }
        else {
            sortOrder = SORT_ORDER.ASC;
        }
        if (sortColumnName !== sortColKey) {
            sortColumnName = sortColKey;
            sortOrder = SORT_ORDER.ASC;
        }
        var data = __spreadArray([], tableData, true);
        switch (colDataType) {
            case "string": {
                data.sort(function (a, b) {
                    var nameA = a[sortColKey] ? a[sortColKey].toUpperCase() : "";
                    var nameB = b[sortColKey] ? b[sortColKey].toUpperCase() : "";
                    if (sortOrder === SORT_ORDER.ASC) {
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                    }
                    else {
                        if (nameA < nameB) {
                            return 1;
                        }
                        if (nameA > nameB) {
                            return -1;
                        }
                    }
                    return 0;
                });
                break;
            }
            case "number": {
                if (sortOrder === SORT_ORDER.ASC) {
                    data.sort(function (firstItem, secondItem) {
                        return firstItem[sortColKey] - secondItem[sortColKey];
                    });
                }
                else {
                    data.sort(function (firstItem, secondItem) {
                        return secondItem[sortColKey] - firstItem[sortColKey];
                    });
                }
                break;
            }
            case "date": {
                if (sortOrder === SORT_ORDER.ASC) {
                    data.sort(function (firstItem, secondItem) {
                        return moment
                            .utc(firstItem[sortColKey])
                            .diff(moment.utc(secondItem[sortColKey]));
                    });
                }
                else {
                    data.sort(function (firstItem, secondItem) {
                        return moment
                            .utc(secondItem[sortColKey])
                            .diff(moment.utc(firstItem[sortColKey]));
                    });
                }
                break;
            }
        }
        setTableData(data);
    };
    useEffect(function () {
        if (dataToDisplay) {
            setTableData(dataToDisplay);
            setCurrentPage(activePage ? activePage : 1);
        }
    }, [dataToDisplay]);
    useEffect(function () {
        if (activePage != null && activePage >= 1) {
            setCurrentPage(activePage);
        }
        if (recordsPerPage != null && recordsPerPage >= 1) {
            setPerPageCount(recordsPerPage);
        }
    }, [activePage, recordsPerPage]);
    var initializedRef = React.useRef(false);
    useEffect(function () {
        if (initializedRef.current)
            return;
        var total = totalNumberOfRecords != null
            ? totalNumberOfRecords
            : activePage
                ? 0
                : tableData.length;
        if (total > 0) {
            initializedRef.current = true;
            setPerPageCount(50);
            setCurrentPage(1);
            if (setActivePage) {
                setActivePage(1);
            }
            if (setRecordsPerPage) {
                setRecordsPerPage(50);
            }
        }
    }, [totalNumberOfRecords, tableData.length, activePage, setActivePage, setRecordsPerPage]);
    var getTableNoDataText = function () {
        if (isLoading) {
            return "Loading...";
        }
        if (isPortalSelected === null) {
            return "Please Select Portal Name";
        }
        return "No Data Available";
    };
    var getFilterData = function () {
        if (activePage) {
            return tableData;
        }
        else {
            var __tableData = tableData.filter(function (item, index) {
                var min = perPageCount * currentPage - perPageCount;
                var max = perPageCount * currentPage;
                if (index >= min && index < max) {
                    return item;
                }
            });
            return __tableData;
        }
    };
    var totalRecordsForPagination = totalNumberOfRecords !== null && totalNumberOfRecords !== void 0 ? totalNumberOfRecords : tableData.length;
    var totalPages = Math.max(1, Math.ceil(totalRecordsForPagination / perPageCount));
    var canGoPrev = currentPage > 1;
    var canGoNext = currentPage < totalPages;
    var rowOptions = [50, 100, 200, 250];
    var getVisiblePages = function () {
        if (totalPages <= 7) {
            return Array.from({ length: totalPages }, function (_, idx) { return idx + 1; });
        }
        if (currentPage <= 3 || currentPage >= totalPages - 2) {
            return [1, 2, 3, "ellipsis", totalPages - 2, totalPages - 1, totalPages];
        }
        return [1, "ellipsis", currentPage - 1, currentPage, currentPage + 1, "ellipsis", totalPages];
    };
    var visiblePages = getVisiblePages();
    var handlePageChange = function (page) {
        setCurrentPage(page);
        if (setActivePage) {
            setActivePage(page);
        }
    };
    var handleRowsChange = function (value) {
        setPerPageCount(value);
        setCurrentPage(1);
        if (setActivePage) {
            setActivePage(1);
        }
        if (setRecordsPerPage) {
            setRecordsPerPage(value);
        }
    };
    return (React.createElement(Box, { className: "module-table-root ".concat(wrapperClassName).trim() },
        React.createElement(TableContainer, { component: Paper, className: "table-component", onScroll: function () { return setScrollCounter(function (prevState) { return prevState + 1; }); }, sx: { maxHeight: tableContainerMaxHeight } },
            React.createElement(Table, { sx: { minWidth: 650 }, "aria-label": "simple table", stickyHeader: true },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        columns.map(function (col, index) {
                            return (React.createElement(StyledTableCell, { key: index, className: "txt-elipsis", sx: __assign({ textAlign: index === 0 || customerPoratl ? "left" : "center" }, (col.width && { width: col.width, minWidth: col.width })) },
                                col.label,
                                col.hasSort && (React.createElement(IconButton, { onClick: function () { return handleSort(col.apiKey, col.colDataType); } },
                                    React.createElement(Box, { sx: { display: 'inline-flex', alignItems: 'center', gap: 0.5 } },
                                        React.createElement("span", { className: "icon-import_export", style: { fontSize: 16, lineHeight: 1 } }))))));
                        }),
                        isActionColumn !== false && (React.createElement(StyledTableCell, { sx: { textAlign: "center" } }, "Actions")))),
                React.createElement(TableBody, null, (tableData === null || tableData === void 0 ? void 0 : tableData.length) ? (getFilterData().map(function (row, idx) {
                    var _a;
                    return (React.createElement(TableRow, { key: idx, style: {
                            cursor: customerPoratl
                                ? isRowClickEnabled
                                    ? "pointer"
                                    : ""
                                : "pointer",
                        } },
                        React.createElement(React.Fragment, null,
                            columns.map(function (col, index) {
                                return (React.createElement(StyledTableCell, { key: index, sx: __assign({ textAlign: index === 0 || customerPoratl
                                            ? "left"
                                            : "center" }, (col.width && { width: col.width, minWidth: col.width })), onClick: function () {
                                        return onClickHandler &&
                                            isRowClickEnabled &&
                                            onClickHandler(row);
                                    } }, getRowData(index, col.apiKey, row[col.apiKey], row, col)));
                            }),
                            isActionColumn !== false && (React.createElement(StyledTableCell, { className: "action-col", sx: { textAlign: "center" } }, moduleName ===
                                "Customer Portal User Management" ? (React.createElement(Stack, { direction: "row", spacing: 0.5, alignItems: "center", justifyContent: customerPoratl ? "center" : "" },
                                !hideEditIcon && (React.createElement(IconButton, { size: "small", onClick: function () {
                                        return actionHandler && actionHandler(row, "Edit");
                                    }, sx: { color: "text.secondary" } },
                                    React.createElement(EditPencilIcon, null))),
                                React.createElement(BasicPopover, { rowData: row, tooltipActionHandler: actionHandler, moduleType: moduleName, scrollCounter: scrollCounter, useCustomerPortalMenu: useCustomerPortalMenu, hideEditIcon: hideEditIcon, hasDelete: hasDelete, canUpdate: canUpdate, showImpersonate: showImpersonate }))) : moduleName === "Customer Portal Registration Management" &&
                                useCustomerPortalMenu ? (React.createElement(Stack, { direction: "row", spacing: 1, justifyContent: "center" },
                                row.RegistrationLink && (React.createElement(Tooltip, { title: moment(row.RegistrationLinkExpiry).isBefore(moment()) ? "Link expired" : "Copy Link" },
                                    React.createElement("span", null,
                                        React.createElement(IconButton, { size: "small", disabled: moment(row.RegistrationLinkExpiry).isBefore(moment()), onClick: function () { return actionHandler && actionHandler(row, "CopyLink"); }, sx: {
                                                borderColor: moment(row.RegistrationLinkExpiry).isBefore(moment()) ? "#cccccc" : "#1a2a5e",
                                                border: "1px solid",
                                                borderRadius: 1,
                                                color: moment(row.RegistrationLinkExpiry).isBefore(moment()) ? "#999999" : "#1a2a5e",
                                                opacity: moment(row.RegistrationLinkExpiry).isBefore(moment()) ? 0.5 : 1,
                                                cursor: moment(row.RegistrationLinkExpiry).isBefore(moment()) ? "not-allowed" : "pointer",
                                                "&:hover": {
                                                    borderColor: moment(row.RegistrationLinkExpiry).isBefore(moment()) ? "#cccccc" : "#1a2a5e",
                                                    bgcolor: moment(row.RegistrationLinkExpiry).isBefore(moment()) ? "transparent" : "rgba(26, 42, 94, 0.04)",
                                                },
                                            } },
                                            React.createElement(FileCopyIcon, { sx: { fontSize: 16 } }))))),
                                ((_a = row.RegistrationStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== "completed" && (React.createElement(Button, { size: "small", variant: "outlined", startIcon: React.createElement(ReplayIcon, { sx: { fontSize: 16 } }), onClick: function () { return actionHandler && actionHandler(row, "ResendLink"); }, sx: {
                                        textTransform: "none",
                                        borderColor: "#059669",
                                        color: "#059669",
                                        fontWeight: 600,
                                        fontSize: 13,
                                        px: 1.5,
                                        "&:hover": {
                                            borderColor: "#059669",
                                            bgcolor: "rgba(5, 150, 105, 0.04)",
                                        },
                                    } }, "Resend")))) : moduleName === "ROLES_PERMISSIONS" &&
                                isActionColumn ? (React.createElement(Button, { component: "button", variant: "text", endIcon: React.createElement(ArrowRightAltIcon, null), onClick: function () {
                                    return actionHandler && actionHandler(row, "Manage");
                                }, sx: {
                                    color: "#2563EB",
                                    textDecoration: "none",
                                    cursor: "pointer",
                                    fontWeight: 500,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                } }, "Manage")) : moduleName ===
                                "Customer Portal Payment Management" ? (React.createElement(Link, { component: "button", variant: "body2", onClick: function () {
                                    return actionHandler &&
                                        actionHandler(row, "Push to Aspire");
                                }, sx: {
                                    color: "#2563EB",
                                    textDecoration: "none",
                                    cursor: "pointer",
                                    fontWeight: 500,
                                    "&:hover": {
                                        textDecoration: "underline",
                                    },
                                } }, "Push to Aspire")) : (React.createElement(BasicPopover, { rowData: row, tooltipActionHandler: actionHandler, moduleType: moduleName, scrollCounter: scrollCounter, hideEditIcon: hideEditIcon, hasDelete: hasDelete, canUpdate: canUpdate, showImpersonate: showImpersonate })))))));
                })) : (React.createElement(TableRow, { className: "no-data-text" },
                    React.createElement(StyledTableCell, { colSpan: columns.length + 1 },
                        React.createElement(Typography, { textAlign: "center", fontSize: "14px", fontWeight: 600 }, getTableNoDataText()))))))),
        !hidePagination && (tableData === null || tableData === void 0 ? void 0 : tableData.length) > 0 && totalRecordsForPagination > 5 && (React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", width: "100%", pb: 0.5 },
            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
                React.createElement(Typography, { variant: "body2", sx: { fontSize: 14, fontWeight: 500, color: "#262F3F", whiteSpace: "nowrap" } }, "Rows per page:"),
                React.createElement(Select, { value: perPageCount, onChange: function (e) { return handleRowsChange(Number(e.target.value)); }, size: "small", sx: {
                        fontSize: 14,
                        fontWeight: 600,
                        height: 34,
                        minWidth: 70,
                        color: "#262F3F",
                        backgroundColor: "#FFFFFF",
                        ".MuiOutlinedInput-notchedOutline": {
                            borderColor: "#D9DEE7",
                            borderRadius: "8px",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#B0B8C9",
                        },
                        ".MuiSelect-select": {
                            py: 0,
                            px: 1.5,
                        },
                    } }, rowOptions.map(function (opt) { return (React.createElement(MenuItem, { key: opt, value: opt, sx: { fontSize: 14 } }, opt)); }))),
            React.createElement(Stack, { direction: "row", alignItems: "center", sx: {
                    border: "1px solid #D9DEE7",
                    borderRadius: "8px",
                    overflow: "hidden",
                    backgroundColor: "#FFFFFF",
                } },
                React.createElement(Button, { onClick: function () { return canGoPrev && handlePageChange(currentPage - 1); }, disabled: !canGoPrev, startIcon: React.createElement(ArrowBackIcon, { sx: { fontSize: 14 } }), sx: {
                        minWidth: "auto",
                        px: 1.5,
                        py: 0.5,
                        minHeight: 34,
                        borderRadius: 0,
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: 14,
                        color: "#262F3F",
                        borderRight: "1px solid #D9DEE7",
                        "&.Mui-disabled": {
                            color: "#9AA5B1",
                        },
                    } }, "Previous"),
                visiblePages.map(function (page, idx) {
                    if (page === "ellipsis") {
                        return (React.createElement(Box, { key: "ellipsis-".concat(idx), sx: {
                                minWidth: 34,
                                height: 34,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRight: "1px solid #D9DEE7",
                                color: "#9AA5B1",
                                fontSize: 14,
                            } }, "..."));
                    }
                    var isActive = currentPage === page;
                    return (React.createElement(Box, { key: page, onClick: function () { return handlePageChange(page); }, sx: {
                            minWidth: 34,
                            height: 34,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            borderRight: "1px solid #D9DEE7",
                            backgroundColor: isActive ? "#EEF2F7" : "#FFFFFF",
                            color: "#262F3F",
                        } },
                        React.createElement(Typography, { variant: "body2", fontWeight: isActive ? 700 : 500 }, page)));
                }),
                React.createElement(Button, { onClick: function () { return canGoNext && handlePageChange(currentPage + 1); }, disabled: !canGoNext, endIcon: React.createElement(ArrowForwardIcon, { sx: { fontSize: 14 } }), sx: {
                        minWidth: "auto",
                        px: 1.5,
                        py: 0.5,
                        minHeight: 34,
                        borderRadius: 0,
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: 14,
                        color: "#262F3F",
                        "&.Mui-disabled": {
                            color: "#9AA5B1",
                        },
                    } }, "Next"))))));
};
export default React.memo(ModuleTable);
